// extracted by mini-css-extract-plugin
module.exports = {"searchbarWrapper":"search-bar_searchbarWrapper__iM28c","searchBar":"search-bar_searchBar__24wRe","searchIcon":"search-bar_searchIcon__1ihHV"};